import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RemoveBankAccountMutationVariables = Types.Exact<{
  account_id: Types.Scalars["String"];
}>;

export type RemoveBankAccountMutation = { __typename?: "mutation_root" } & {
  delete_bank_accounts?: Types.Maybe<
    { __typename?: "bank_accounts_mutation_response" } & {
      returning: Array<
        { __typename?: "bank_accounts" } & Pick<
          Types.Bank_Accounts,
          "id" | "currency_book_id"
        >
      >;
    }
  >;
};

export const RemoveBankAccountDocument = gql`
  mutation RemoveBankAccount($account_id: String!) {
    delete_bank_accounts(where: { account_id: { _eq: $account_id } }) {
      returning {
        id
        currency_book_id
      }
    }
  }
`;

export function useRemoveBankAccountMutation() {
  return Urql.useMutation<
    RemoveBankAccountMutation,
    RemoveBankAccountMutationVariables
  >(RemoveBankAccountDocument);
}
